module.exports = __webpack_public_path__ + "img/temp.940dc383.jpg";